/**
 * A phone or a tablet: small screen, or a touch screen as the main pointer.
 *
 * The screen size, not the window: once a visitor picks "Continue in the
 * browser", main.tsx forces a 1280 px layout on the dashboard, so the window
 * width no longer tells a phone apart.
 */
export function isPhoneOrTablet(): boolean {
  if (typeof window === 'undefined') return false
  const small = Math.min(window.screen.width, window.screen.height) < 768
  const touch = window.matchMedia?.('(pointer: coarse)').matches ?? false
  return small || touch
}
